<template>
  <div class="home">
    <myheader></myheader>
    <div class="contactUs" @mouseenter="showus = true" @mouseleave="showus = false">
      <img src="../assets/img/contactUs/kf-ico.png" alt="" class="kf-ico">
      <span class="kf-text">联系我们</span>
    </div>
    <div class="infobox" v-show="showus" >
      <div class="info-text1">客服咨询</div>
      <div class="info-row">
        <img src="../assets/img/contactUs/kf-ico1.png" alt="" class="kf-ico1">
        <div class="dhbox">
          <div class="info-text2">电话热线</div>
          <div class="info-text3">400 666 6011</div>
        </div>
      </div>
      <div class="kbbox"></div>

      <div class="info-text1">技术咨询</div>
      <div class="info-row">
        <img src="../assets/img/contactUs/kf-ico2.png" alt="" class="kf-ico1">
        <div class="dhbox">
          <div class="info-text2">许经理</div>
          <div class="info-text3">1590 126 5905</div>
        </div>
      </div>
      
    </div>
      <img src="../assets/img/contactUs/toright.png" alt="" class="toright" v-show="showus">
    <div class="content">

      <div >
        <router-view />
      </div>
     
    </div>

    <mybottom class="bottombox"></mybottom>




  </div>
</template>

<script lang="ts" setup>
import { defineComponent, onMounted, ref, reactive } from 'vue';
import myheader from './header.vue'
import mybottom from './bottom.vue'

import type { ComponentSize, FormInstance, FormRules } from 'element-plus'
import {
  CircleCheckFilled,
} from '@element-plus/icons-vue'
import tmMitt from "../utils/tmMitt.ts";
import { getcode, addUser } from '../utils/axios'
import { ElMessage } from 'element-plus'
import { isMobile } from '../utils/validate'


// tmMitt.on("openinfo", (data) => {
//   console.log("openinfo", data);
//   showRegister.value = true
//   ruleForm.value.registrationType = data.type
// });


let showus = ref(false)





onMounted(() => {
  // ElMessage({
  //   duration:0,
  //   showClose: true,
  //   message: 'Congrats, this is a success message.',
  //   type: 'success',
  // })

})






</script>
<style lang="scss" scoped>
.contactUs {
  width: 24px;
  height: 130px;
  position: fixed;
  right: 24px;
  top: 530px;
  z-index: 9999;
  font-size: 14px;
  display: flex;
  justify-content: space-evenly;
  padding: 3px 10px;
  align-items: center;
  cursor: pointer;
  border-radius: 40px;
  background: var(--Color-Branding-blue, #3461FF);
  box-shadow: 0px 15px 35px -2px rgba(0, 0, 0, 0.05), 0px 5px 15px 0px rgba(0, 0, 0, 0.03);
  writing-mode: vertical-lr;
  text-align: center;



}

.kf-text {
  color: var(--www-volcengine-com-nero, #FFF);
  
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.content {
  // min-height: calc(100vh - 240px);
  flex: 1;
}

.home {
  min-width: 1200px;
  overflow-x: hidden;
  display: flex;  
    flex-direction: column;  
    min-height: 100vh;  
}

.kf-ico {
  width: 21px;
  height: 21px;
}

.infobox {
  position: fixed;
  right: 90px;
  top: 440px;
  // display: flex;
  // width: 287px;
  height: 250px;
  background-color: #FFF;
  width: 200px;
  padding: 24px;
  border-radius: var(--Radius-Border-radius-4, 8px);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  z-index: 9999;

}

.kf-ico1 {
  width: 45px;
  height: 45px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-top: 10px;

 

}

.info-text1 {
  color: var(--Color-Neutral-neutral-10, #64666B);
  
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.info-text2 {
  color: var(--Color-Neutral-neutral-10, #64666B);
  
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}

.info-text3 {
  color: var(--Color-Neutral-neutral-11, #323335);
  
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.dhbox{
  margin-left: 10px;
}
.kbbox{
  width: 100%;
  height: 20px;
}
.toright{
  position: fixed;
  right: 58px;
  top: 560px;
  height: 16px;
  width: 8px;
  padding: 24px;
  z-index: 9999;
}
.bottombox{
   position: relative;
}
</style>
